import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class AppState {
    private _isLoading = signal(true);
    public isLoading = this._isLoading.asReadonly();
    public setIsLoading(value: boolean) {
        this._isLoading.set(value);
    }

    private _authorName = signal<string | undefined>(undefined);
    public authorName = this._authorName.asReadonly();
    public setAuthorName(name: string | undefined) {
        this._authorName.set(name);
    }
}
